import request from "@/api/request";
import { VideoList } from "@/interfaces/Video/VideoList";
import { Video } from "@/interfaces/Video/Video";
import { PlaybackParams } from "@/interfaces/Video/PlaybackParams.ts";
import { Tag } from "@/interfaces/Tags/Tag.ts";

class VideoService {
  static async getList(props: {
    page: number;
    order: string;
    tags: Array<number>;
    term: string;
    search_type: string | null;
  }): Promise<VideoList> {
    return request.get("/videos", props);
  }

  static async getVideo(id: number): Promise<Video> {
    return request.get(`/videos/${id}`);
  }

  static async playback(id: number, props: PlaybackParams): Promise<void> {
    return request.post(`/videos/${id}/playback`, props);
  }

  static async getUnlockedVideos(): Promise<Array<number>> {
    return request.get("/videos/unlocked");
  }

  static async setUnlockedVideos(token: string): Promise<Video[]> {
    return request.post("/videos/unlocked", { token });
  }

  static async getPlaybackData(id: number): Promise<Record<number, Record<number, number>>> {
    return request.get(`/videos/${id}/playbacks`);
  }

  static async getSimilar(id: number | string): Promise<Video[]> {
    return await request.get(`/videos/${id}/similar`);
  }

  static async getRandom(): Promise<Video> {
    return request.get("/videos/random");
  }
  static async getTags(): Promise<Tag[]> {
    return request.get("/videos/tags");
  }
}

export default VideoService;
